"use strict";

/**
 * @classdesc
 * FachDB-Featureobjekt als Ergebnis einer Query-Funktion des FeatureServices.
 *
 * @class
 * @extends gc.gis.service.feature.AbstractQueryFeature
 * @memberof gc.gis.service
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.service.feature.QueryFachDBFeature = function()
{
	gc.gis.service.feature.AbstractQueryFeature.call(this);

	/**
	 * Fachbezug Geometrie
	 * @type {Object[]}
	 * @private
	 */
	this._geometryList = [];

	/**
	 * Fachbezug Adresse
	 * @type {Object[]}
	 * @private
	 */
	this._adressList = [];

	/**
	 * Fachbezug Flurstück
	 * @type {Object[]}
	 * @private
	 */
	this._landparcelList = [];

	/**
	 * Fachbezug Media.
	 * @type {Object[]}
	 * @private
	 */
	this._mediaList = [];

};
gc.gis.service.feature.QueryFachDBFeature.prototype = Object.create(gc.gis.service.feature.AbstractQueryFeature.prototype);

/**
 * Liefert eine Liste von Geometrien aller Koordinatenbeüge.
 *
 * @return {gc.gis.geom.GCGeometry[]}
 */
gc.gis.service.feature.QueryFachDBFeature.prototype.getGeometries = function ()
{
	var geoms = [], i, ii;

	for (i = 0, ii = this._geometryList.length; i < ii; i++)
	{
		if (this._geometryList[i].geometry instanceof gc.gis.geom.GCGeometry)
		{
			geoms.push(this._geometryList[i].geometry);
		}
	}

	return geoms;
};

/**
 * {@inheritDoc}
 */
gc.gis.service.feature.QueryFachDBFeature.prototype.getGeometry = function ()
{
	var geoms = this.getGeometries();

	if (geoms.length === 1)
	{
		return geoms[0];
	}
	else if (geoms.length > 1)
	{
		var col = gc.gis.iface.mapFactory.createGeometryCollection();
		col.setGeometries(geoms);

		return col;
	}

	return null;
};

/**
 * Liefert die Koordinatenbezüge.
 *
 * @return {Object[]}
 */
gc.gis.service.feature.QueryFachDBFeature.prototype.getGeometryList = function ()
{
	return this._geometryList;
};

/**
 * Setzt die Koordinatenbezüge.
 *
 * @param {Object[]} geometryList
 * @return {gc.gis.service.feature.QueryFachDBFeature}
 */
gc.gis.service.feature.QueryFachDBFeature.prototype.setGeometryList = function (geometryList)
{
	this._geometryList = geometryList;
	return this;
};

/**
 * Liefert die Adressbezüge.
 *
 * @return {Object[]}
 */
gc.gis.service.feature.QueryFachDBFeature.prototype.getAddressList = function ()
{
	return this._adressList;
};

/**
 * Setzt die Adressbezüge.
 *
 * @param {Object[]} adressList
 * @return {gc.gis.service.feature.QueryFachDBFeature}
 */
gc.gis.service.feature.QueryFachDBFeature.prototype.setAddressList = function (adressList)
{
	this._adressList = adressList;
	return this;
};

/**
 * Liefert die Adressbezüge.
 *
 * @return {Object[]}
 */
gc.gis.service.feature.QueryFachDBFeature.prototype.getLandparcelList = function ()
{
	return this._landparcelList;
};

/**
 * Setzt die Adressbezüge.
 *
 * @param {Object[]} landparcelList
 * @return {gc.gis.service.feature.QueryFachDBFeature}
 */
gc.gis.service.feature.QueryFachDBFeature.prototype.setLandparcelList = function (landparcelList)
{
	this._landparcelList = landparcelList;
	return this;
};

/**
 * Liefert die Medienbezüge.
 *
 * @return {Object[]}
 */
gc.gis.service.feature.QueryFachDBFeature.prototype.getMediaList = function ()
{
	return this._mediaList;
};

/**
 * Setzt die Medienbezüge.
 *
 * @param {Object[]} mediaList
 * @return {gc.gis.service.feature.QueryFachDBFeature}
 */
gc.gis.service.feature.QueryFachDBFeature.prototype.setMediaList = function (mediaList)
{
	this._mediaList = mediaList;
	return this;
};